import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const http = axios.create({ baseURL: API, timeout: 20000 });

// Normalise backend errors into { message, errors }
const normalizeError = (err) => {
  const data = err?.response?.data;
  if (data && typeof data === "object") {
    return { message: data.message || "Something went wrong. Please try again.", errors: data.errors || {} };
  }
  if (err?.code === "ECONNABORTED") {
    return { message: "Request timed out. Please check your connection and try again.", errors: {} };
  }
  return { message: "Unable to reach the server. Please try again.", errors: {} };
};

export const submitEnquiry = async (payload) => {
  try {
    const { data } = await http.post("/enquiries", payload);
    return data;
  } catch (err) {
    throw normalizeError(err);
  }
};

export const submitContactMessage = async (payload) => {
  try {
    const { data } = await http.post("/contact-messages", payload);
    return data;
  } catch (err) {
    throw normalizeError(err);
  }
};

export const submitCollegeSession = async (payload) => {
  try {
    const { data } = await http.post("/college-session-requests", payload);
    return data;
  } catch (err) {
    throw normalizeError(err);
  }
};

export const submitCourseRecommendation = async (payload) => {
  try {
    const { data } = await http.post("/course-recommendation", payload);
    return data;
  } catch (err) {
    throw normalizeError(err);
  }
};

export const submitCareerApplication = async (formData) => {
  try {
    const { data } = await axios.post(`${API}/career-applications`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  } catch (err) {
    throw normalizeError(err);
  }
};

export const submitInternship = async (formData) => {
  try {
    const { data } = await http.post("/internship-applications", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  } catch (err) {
    throw normalizeError(err);
  }
};

// -------- shared option lists (client-side)
export const MODES = ["Online", "Offline", "Hybrid"];
export const GENDERS = ["Male", "Female", "Prefer not to say"];
export const QUALIFICATIONS = [
  "10th",
  "12th",
  "Diploma",
  "Undergraduate",
  "Graduate",
  "Postgraduate",
  "Other",
];
export const CURRENT_YEARS = ["1st Year", "2nd Year", "3rd Year", "Final Year", "Graduated"];

// Indian mobile client-side check (mirror of backend)
export const isValidIndianMobile = (v) => {
  let d = (v || "").replace(/\D/g, "");
  // Match backend: only strip a leading '91' when the total length is 12,
  // or a leading '0' when the total length is 11. Otherwise leave as-is.
  if (d.length === 12 && d.startsWith("91")) d = d.slice(2);
  else if (d.length === 11 && d.startsWith("0")) d = d.slice(1);
  return /^[6-9]\d{9}$/.test(d);
};
export const isValidEmail = (v) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test((v || "").trim());
